<script>
export default {
  computed: {
    countNewMessages () {
      return this.$store.state.websocket.unreadMessage.unreadTotal
    }
  }
}
</script>
